import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { motion } from 'motion/react';
import { Dialog as Primitive } from 'radix-ui';

import {
  composeModalHandlers,
  useModalPartsContext,
} from '@components/primitives/focus';

type DialogContentEventProps = Pick<
  ComponentPropsWithoutRef<typeof Primitive.Content>,
  | 'onOpenAutoFocus'
  | 'onCloseAutoFocus'
  | 'onEscapeKeyDown'
  | 'onPointerDownOutside'
  | 'onInteractOutside'
  | 'onFocusOutside'
>;

export type DialogContentProps = Omit<
  ComponentPropsWithoutRef<typeof motion.div>,
  keyof DialogContentEventProps
> &
  DialogContentEventProps;

export const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(
  function DialogContent(
    {
      onOpenAutoFocus,
      onCloseAutoFocus,
      onEscapeKeyDown,
      onPointerDownOutside,
      onInteractOutside,
      onFocusOutside,
      ...props
    },
    ref
  ) {
    const parts = useModalPartsContext();

    return (
      <Primitive.Content
        onOpenAutoFocus={composeModalHandlers(
          parts.onOpenAutoFocus,
          onOpenAutoFocus
        )}
        onCloseAutoFocus={composeModalHandlers(
          parts.onCloseAutoFocus,
          onCloseAutoFocus
        )}
        onEscapeKeyDown={composeModalHandlers(
          parts.onEscapeKeyDown,
          onEscapeKeyDown
        )}
        onPointerDownOutside={onPointerDownOutside}
        onInteractOutside={onInteractOutside}
        onFocusOutside={onFocusOutside}
        asChild
      >
        <motion.div ref={ref} {...props} />
      </Primitive.Content>
    );
  }
);
